module.exports = __webpack_public_path__ + "dist/img/subscribe.7448628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subscribe.jpg
// module id = kFRv
// module chunks = 1